import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/news-hero.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import { HeroSection, EmergencyCTASection } from "../../components";
import { NewsUpdatesPage } from "@features/general";

export function NewsUpdates() {
  return (
    <NewsUpdatesPage
      hero={
        <HeroSection
          title="Latest News, Safety Alerts & Company Updates"
          description="Stay informed about new services, tariff updates, safety announcements, community programs, and company developments from Gas Integrated Solutions L.L.C. (GASIS)."
          heroImage={heroImage}
        />
      }
      footer={
        <>
          <EmergencyCTASection
            title="Need Help or Have a Question?"
            subtitle={
              <>
                Call our 24/7 Emergency Line: 800-GASIS (42747)
                <br />
                or report a concern via our Online Safety Form.
              </>
            }
          >
            <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
              <div className="flex items-center gap-2.5">
                <img src={mailIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  help@gasis.ae
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={phoneIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  Support (8 AM – 8 PM)
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={buildingIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  Sunday – Thursday (8 AM – 6 PM)
                </span>
              </div>
            </div>
          </EmergencyCTASection>
          <Footer />
        </>
      }
    />
  );
}

export default NewsUpdates;
